import { render, staticRenderFns } from "./Prodetail.vue?vue&type=template&id=643a4d74&scoped=true&"
import script from "./Prodetail.vue?vue&type=script&lang=js&"
export * from "./Prodetail.vue?vue&type=script&lang=js&"
import style0 from "./Prodetail.vue?vue&type=style&index=0&id=643a4d74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643a4d74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('643a4d74')) {
      api.createRecord('643a4d74', component.options)
    } else {
      api.reload('643a4d74', component.options)
    }
    module.hot.accept("./Prodetail.vue?vue&type=template&id=643a4d74&scoped=true&", function () {
      api.rerender('643a4d74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Prodetail.vue"
export default component.exports